import ReactGA from 'react-ga4';

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-XXXXXXXXXX'; // Placeholder

export const initGA = () => {
  // Check if Google Analytics should be loaded based on cookie consent
  const consent = localStorage.getItem('cookieConsent');
  
  if (!consent) {
    // No consent yet, wait for banner
    return;
  }

  try {
    const preferences = JSON.parse(consent);
    
    if (preferences.analytics) {
      ReactGA.initialize(TRACKING_ID, {
        gaOptions: {
          anonymizeIp: true,
        }
      });
      
      console.log('Google Analytics initialized');
    }
  } catch (error) {
    console.error('Error initializing Google Analytics:', error);
  }
};

export const logPageView = () => {
  const consent = localStorage.getItem('cookieConsent');
  
  if (consent) {
    try {
      const preferences = JSON.parse(consent);
      if (preferences.analytics) {
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
      }
    } catch (error) {
      console.error('Error logging page view:', error);
    }
  }
};

export const logEvent = (category, action, label) => {
  const consent = localStorage.getItem('cookieConsent');
  
  if (consent) {
    try {
      const preferences = JSON.parse(consent);
      if (preferences.analytics) {
        ReactGA.event({
          category,
          action,
          label,
        });
      }
    } catch (error) {
      console.error('Error logging event:', error);
    }
  }
};

export default { initGA, logPageView, logEvent };
